var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49 9.49695C4.33 9.49695 3.426 9.17295 2.778 8.52495C2.13 7.86895 1.806 6.93295 1.806 5.71695V0.976953H3.366V5.65695C3.366 7.30495 4.078 8.12895 5.502 8.12895C6.918 8.12895 7.626 7.30495 7.626 5.65695V0.976953H9.162V5.71695C9.162 6.93295 8.838 7.86895 8.19 8.52495C7.55 9.17295 6.65 9.49695 5.49 9.49695Z",
    fill: "#5D616F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.577H10.218V11.177H0.75V10.577Z",
    fill: "#5D616F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.7b2e25e63175bcfe0f49ef551d3f25db.svg";
export { ForwardRef as ReactComponent };